import styles from '../styles/components/Poll.module.css'

const PollGroup = () => {
  return ( 
    <span className={styles.warning}>Polls are not supported</span>
  );
}
 
export default PollGroup;